import React from 'react';
import Link from '../../../components/Link';
import MainContainer from '../../Main'
import { FormattedMessage } from 'react-intl';

//компонент отчетов для роли персоны, требует редиректа на главную страницу при разлогировании
const Reporting = () => {
    return (
        <MainContainer>
           <h1>страница отчетности персоны</h1> 
        </MainContainer> 
    )
}

export default Reporting;


// WEBPACK FOOTER //
// ./src/containers/roles/person/Reporting.jsx